import { deleteEmailWorkflow } from "../../../../../actions/Utilities/EmailWorkFlow";
import { useMutation } from "react-query";
const useDeleteEmailWorkflow = () => {
  return useMutation(deleteEmailWorkflow);
};
export default useDeleteEmailWorkflow;
